
export default function About() {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              About <strong>ASELCO S.R.L.</strong>
            </h2>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              We are a dedicated team of experts specializing in the development of modern applications for the iOS platform. Our mission is to create innovative solutions that not only meet but exceed user expectations in terms of functionality, design, and security.
            </p>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              With years of experience in mobile application development, we focus on delivering products that enhance user experience while maintaining the highest standards of security and performance. Our applications are designed with the end-user in mind, ensuring intuitive interfaces and robust functionality.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed">
              At ASELCO S.R.L., we believe in continuous innovation and staying ahead of technological trends to provide our users with the best possible mobile experience on iOS devices.
            </p>
          </div>
          
          <div className="relative">
            <div className="w-full h-full">
              <img 
                src="https://public.readdy.ai/ai/img_res/fd7194c104f2b069e469f77b40ddf494.jpg"
                alt="ASELCO Team"
                className="w-full h-full object-cover object-top rounded-lg shadow-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
